var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4329 8.8632C23.2731 8.98116 20.4697 10.4809 20.4697 13.8172C20.4697 17.6759 24.0361 19.0408 24.1426 19.0744C24.1249 19.1586 23.5748 20.9448 22.2618 22.7646C21.0908 24.3655 19.8664 25.9662 18.0034 25.9662C16.1404 25.9662 15.6613 24.9383 13.5143 24.9383C11.4206 24.9383 10.6753 25.9999 8.97196 25.9999C7.26858 25.9999 6.07974 24.517 4.7136 22.6972C3.13443 20.5572 1.85693 17.2377 1.85693 14.0867C1.85693 9.03158 5.31695 6.35229 8.72354 6.35229C10.5334 6.35229 12.0415 7.4813 13.1771 7.4813C14.2594 7.4813 15.9451 6.2849 18.0032 6.2849C18.7841 6.28507 21.5876 6.35261 23.4329 8.8632Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0276 4.14522C17.8792 3.18474 18.4826 1.85358 18.4826 0.522415C18.4826 0.337073 18.4649 0.151732 18.4293 0C17.0453 0.0505773 15.3952 0.876293 14.4015 1.97154C13.6208 2.81406 12.8933 4.14522 12.8933 5.49335C12.8933 5.69549 12.9288 5.8978 12.9465 5.96519C13.0352 5.98199 13.1773 5.99896 13.3192 5.99896C14.5613 5.9988 16.1226 5.20685 17.0276 4.14522Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dbbcfa772a1987b1eabb55b058d36740.svg";
export { ForwardRef as ReactComponent };